import React from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import { OUTCOME_LABEL } from "@/lib/attemptLabels";

const pin = (color, n) => L.divIcon({
  className: "",
  html: `<div style="background:${color};color:#fff;width:26px;height:26px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center"><span style="transform:rotate(45deg);font-size:11px;font-weight:700">${n}</span></div>`,
  iconSize: [26, 26], iconAnchor: [13, 26], popupAnchor: [0, -24],
});

function FitBounds({ points }) {
  const map = useMap();
  React.useEffect(() => {
    if (points.length === 1) map.setView(points[0], 15);
    else map.fitBounds(L.latLngBounds(points), { padding: [40, 40] });
  }, [map, points]);
  return null;
}

export function AttemptMap({ attempts = [] }) {
  const pts = attempts.filter((a) => a.gps_lat != null && a.gps_lng != null)
    .sort((a, b) => new Date(a.attempted_at) - new Date(b.attempted_at));
  if (pts.length === 0) return <div className="py-10 text-sm text-slate-400" data-testid="map-empty">No GPS-tagged attempts yet.</div>;
  const latlngs = pts.map((a) => [a.gps_lat, a.gps_lng]);
  return (
    <div className="space-y-3" data-testid="attempt-map">
      <MapContainer center={latlngs[0]} zoom={14} scrollWheelZoom className="w-full h-[460px] rounded border border-slate-200 z-0">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds points={latlngs} />
        {latlngs.length > 1 && <Polyline positions={latlngs} pathOptions={{ color: "#2d7bd0", weight: 2, dashArray: "6 6" }} />}
        {pts.map((a, i) => (
          <Marker key={a.id} position={[a.gps_lat, a.gps_lng]} icon={pin(a.outcome === "served" ? "#16a34a" : "#dc2626", i + 1)}>
            <Popup>
              <div className="text-xs">
                <div className="font-semibold">#{i + 1} · {OUTCOME_LABEL[a.outcome]}</div>
                <div>{new Date(a.attempted_at).toLocaleString()}</div>
                <div className="text-slate-600">{a.address}</div>
                <div className="text-slate-400">{a.gps_lat.toFixed(5)}, {a.gps_lng.toFixed(5)}</div>
                {a.server_name && <div className="text-slate-500">{a.server_name}</div>}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      <ol className="text-xs text-slate-600 space-y-1" data-testid="attempt-map-legend">
        {pts.map((a, i) => (
          <li key={a.id} className="flex items-center gap-2">
            <span className={`inline-flex h-4 w-4 items-center justify-center rounded-full text-white text-[10px] font-bold ${a.outcome === "served" ? "bg-green-600" : "bg-red-600"}`}>{i + 1}</span>
            <span className="font-medium">{new Date(a.attempted_at).toLocaleString()}</span> — {OUTCOME_LABEL[a.outcome]} · {a.gps_lat.toFixed(5)}, {a.gps_lng.toFixed(5)}
          </li>
        ))}
      </ol>
    </div>
  );
}
